import * as React from "react"
import { useState } from "react"
import { Patient } from "../../../../../services/patient.service";
import { SxProps } from "@mui/system";
import { Card, Checkbox, TablePagination, TextField, Theme } from "@mui/material";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableRow from '@mui/material/TableRow';
import Space from "../../../../../components/Space";
import { DuplicatePatientState } from "./duplicate-consult.dialog";

type Props = {
    page: number
    size: number
    total: number
    patients: Patient[]
    query: string
    selectablesPatients: DuplicatePatientState[]
    onQueryChange: (query: string) => void;
    onPageChange: (newPage: number, size: number) => void
    onSizeChange: (newSize: number, page: number) => void
    onSelectedPatient: (patient: number, name: string) => void;
}

interface Header {
    id: 'name'
    label: string
    style?: SxProps<Theme>
}

const headers: readonly Header[] = [
    {
        id: 'name',
        label: 'Consulta',
    }
]

export const PatientTable: React.FC<Props> = (props) => {
    const [perPage] = useState(props.size > 100 ? [10, 25, 50, 100] : [5, 10, 25])

    const handleChangePage = (_: unknown, newPage: number) => {
        props.onPageChange(newPage + 1, props.size)
    }

    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        props.onSizeChange(+event.target.value, 0)
    }

    return (
        <>
            <TextField
                label={'Buscar...'}
                variant="outlined"
                color="primary"
                onChange={(e) => props.onQueryChange(e.target.value)}
                value={props.query}
                sx={{ width: '100%' }}
            />
            <Space pixels={16} direction={'v'}/>
            <Card variant="outlined">
                <TableContainer>
                    <Table aria-label="collapsible patient table">
                        <TableHead>
                            {headers.map((header) =>
                                <TableCell key={header.id} sx={header.style}>
                                    {header.label}
                                </TableCell>
                            )}
                        </TableHead>
                        <TableBody>
                            {props.patients.map((patient) => (
                                <TableRow
                                    key={patient.id}
                                    hover
                                    onClick={() => {props.onSelectedPatient(patient.id, patient.name)}}>
                                    <TableCell component="th" scope="row">
                                        <Checkbox checked={props.selectablesPatients.filter(value => value.id === patient.id).length > 0} />
                                        {patient.name}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>

                <TablePagination
                    page={props.page - 1}
                    component="div"
                    count={props.total}
                    rowsPerPage={props.size}
                    rowsPerPageOptions={perPage}
                    onPageChange={handleChangePage}
                    labelRowsPerPage={""}
                    onRowsPerPageChange={handleChangeRowsPerPage}/>
            </Card>
        </>
    )
}
